import {Base} from './app/services/base';
import {Page} from './app/pages/page';
import {LoginPage} from './app/pages/purchase/loginPage/loginPage';
import {
  ProductPage,
  ProductPageConfig,
} from './app/pages/purchase/productPage/productPage';
import {CheckoutPage} from './app/pages/purchase/checkoutPage/checkoutPage';
import {CheckoutVerifyPage} from './app/pages/purchase/checkoutVerifyPage/checkoutVerifyPage';
import {SuccessPage} from './app/pages/purchase/successPage/successPage';
import {
  LandingPage,
  LandingPageConfig,
} from './app/pages/landingPage/landingPage';
import {FirebaseAuthService} from './app/services/authService/firebaseAuthService';
import {StringNullCallback} from './types/callback';
import {ApiService} from './app/services/api';
import {getEnvConfig} from './app/services/environment';
import {TranslateService} from './app/services/translateService';
import {Session} from './app/services/session';
import {User} from './app/services/user';
import {GtmHelper} from './app/services/gtmHelper';
import {Purchase} from './app/services/purchase';
import {BindingService} from './app/services/bindingService';
import {TimeService} from './app/services/timeService';
import {LoginFlowFactory} from './app/pages/purchase/loginPage/loginFlowFactory';

let page: Page;

const configuration = getEnvConfig();
const api = new ApiService(configuration);
const authService = new FirebaseAuthService(api);
const translateService = new TranslateService(configuration);
const trackingService = new GtmHelper(configuration);
const userService = User.instance;
const purchaseService = new Purchase(configuration, api);
const timeService = new TimeService();
const bindingService = new BindingService(timeService);
const loginFlowFactory = new LoginFlowFactory(
  configuration,
  authService,
  userService,
  trackingService,
);

void (async () => {
  await Base.init({translateService});
})();

export function testIntegration(): void {
  console.log('ok');
}

export function initAsLandingPage(
  d: LandingPageConfig = {preloadProducts: false},
): void {
  page = new LandingPage(
    d,
    configuration,
    authService,
    User.instance,
    trackingService,
    Session.instance,
    bindingService,
    purchaseService,
  );
  Base.renderPageOnReady(page);
}

export function initAsProductPage(pageConfig: ProductPageConfig = {}): void {
  page = new ProductPage(
    pageConfig,
    configuration,
    authService,
    translateService,
    Session.instance,
    User.instance,
    trackingService,
    purchaseService,
    bindingService,
  );
  Base.renderPageOnReady(page);
}

export function initAsLoginPage(): void {
  page = new LoginPage(
    configuration,
    authService,
    translateService,
    Session.instance,
    userService,
    trackingService,
    purchaseService,
    bindingService,
    loginFlowFactory,
  );
  Base.renderPageOnReady(page);
}

export function initAsCheckoutPage(): void {
  page = new CheckoutPage(
    configuration,
    authService,
    translateService,
    Session.instance,
    User.instance,
    trackingService,
    purchaseService,
    bindingService,
  );
  Base.renderPageOnReady(page);
}

export function initAsCheckoutVerifyPage(): void {
  page = new CheckoutVerifyPage(
    configuration,
    authService,
    translateService,
    Session.instance,
    User.instance,
    trackingService,
    purchaseService,
    bindingService,
  );
  Base.renderPageOnReady(page);
}

export function initAsPurchaseCancelPage(): void {
  throw new Error('not implemented');
}

export function initAsPurchaseSuccessPage(): void {
  page = new SuccessPage(
    configuration,
    authService,
    translateService,
    Session.instance,
    userService,
    trackingService,
    purchaseService,
    bindingService,
  );
  Base.renderPageOnReady(page);
}

export const user = {
  async getZendeskIdentificationToken(): Promise<string | null> {
    const result = await api.userTokens.zendeskIdentification();
    if (result.response.success) {
      return result.response.jwt;
    }
    return null;
  },
  getZendeskIdentificationTokenCallback(callback: StringNullCallback): void {
    void this.getZendeskIdentificationToken().then(jwt => {
      callback(jwt);
    });
  },
};
